import React from 'react';
import { SellerEdit3PLCredentialsTemplate } from 'themes/modules/seller/pages';
import { SellerEdit3PLCredentialsViewStore } from '../stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new SellerEdit3PLCredentialsViewStore(rootStore, componentProps),
	'sellerEdit3PLCredentialsViewStore'
)
class SellerEdit3PLCredentials extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<SellerEdit3PLCredentialsTemplate {...this.props} viewStore={this.props.sellerEdit3PLCredentialsViewStore} />
		);
	}
}

export default SellerEdit3PLCredentials;



// WEBPACK FOOTER //
// ./src/modules/seller/pages/SellerEdit3PLCredentials.jsx